export default __webpack_public_path__ + "static/media/rectangles-no-3.e3113a81.mid";